// src/pages/user/AuthorPosts.jsx
import React, { useState, useEffect } from 'react';
import PostItem from '../../components/post/PostItem';
import Loader from '../../components/common/Loader';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { FaArrowLeft } from 'react-icons/fa';

const AuthorPosts = () => {
  const [posts, setPosts] = useState([]);
  const [author, setAuthor] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // Fetch posts by this author
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/posts/users/${id}`);
        setPosts(response?.data || []);
        
        // Also fetch author info if we don't have it
        if (!author) {
          const authorResponse = await axios.get(`${process.env.REACT_APP_BASE_URL}/users/${id}`);
          setAuthor(authorResponse?.data);
        }
        
        setError(null);
      } catch (err) {
        console.error('Error fetching author posts:', err);
        setError('Failed to load posts');
        setPosts([]);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchData();
  }, [id, author]);

  if (isLoading) {
    return (
      <div className="min-h-[300px] flex items-center justify-center py-12">
        <Loader />
      </div>
    );
  }

  return (
    <section className="py-8">
      <div className="container mx-auto px-4">
        <div className="mb-8">
          <Link 
            to={`/profile/${id}`} 
            className="inline-flex items-center text-gray-600 hover:text-primary mb-4"
          >
            <FaArrowLeft className="mr-2" />
            Back to Profile
          </Link>
          
          <h1 className="text-3xl font-bold text-gray-900">
            {author ? `${author.name}'s Posts` : 'Author Posts'}
          </h1>
          {author && posts.length > 0 && (
            <p className="text-gray-600 mt-2">
              Showing {posts.length} {posts.length === 1 ? 'post' : 'posts'} by {author.name}
            </p>
          )}
        </div>
        
        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative mb-6" role="alert">
            <span className="block sm:inline">{error}</span>
          </div>
        )}
        
        {!isLoading && !error && posts.length === 0 ? (
          <div className="text-center py-12 bg-white rounded-lg shadow-sm">
            <h2 className="text-2xl font-bold text-gray-700 mb-2">No Posts Found</h2>
            <p className="text-gray-500">
              {author ? `${author.name} hasn't published any posts yet.` : 'This author has not published any posts yet.'}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {posts.map(({ _id: id, thumbnail, category, title, description, creator, createdAt }) => (
              <PostItem
                key={id}
                postID={id}
                thumbnail={thumbnail}
                category={category}
                title={title}
                description={description}
                authorID={creator}
                createdAt={createdAt}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default AuthorPosts;